import { useCallback, useMemo } from "react";
import { Trans } from "@lingui/macro";
import styled from "@emotion/styled";
import { Refresh } from "src/icons";
import { Sort } from "./components/Sort";
import { ResetAllFilters } from "./components/Facets/Facets.styled";
import { useRemoveFilters } from "src/hooks/use-handle-search-params";
import { Facets, type FacetsProps } from "./components/Facets";
import type { ProductListType } from "src/types/product-listing";
import { useCategoryTreeDispatch } from "src/hooks/context/use-category-tree-context";
import { listingStore } from "src/stores/listing/listing.store";
import { useListingState } from "src/hooks/stores/use-listing-store";

type HeaderSortSectionProps = {
  handleScrollToTop: () => void;
  pageContentType: ProductListType;
  facetsProps: Exclude<FacetsProps, "pageContentType">;
};

const HIDE_SORT_SECTION_PLP_TYPES: ProductListType[] = ["COLLECTIONS_PLP"];

const DesktopSortWrapper = styled.div`
  display: contents;

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    display: none;
  }
`;

function HeaderSortSection({
  handleScrollToTop,
  facetsProps,
  pageContentType,
}: HeaderSortSectionProps): JSX.Element {
  const { removeAllFilters } = useRemoveFilters();
  const treeDispatch = useCategoryTreeDispatch();
  const { appliedFacets } = useListingState();

  const totalFilters = useMemo(
    () => Object.keys(appliedFacets).length,
    [appliedFacets]
  );

  const handleResetAllFilters = useCallback(() => {
    listingStore.setAppliedFacets({});
    removeAllFilters(true);
    treeDispatch({ type: "TRIGGER_RESET", payload: undefined });
    handleScrollToTop();
  }, [removeAllFilters, handleScrollToTop, treeDispatch]);

  return (
    <>
      <Facets {...facetsProps} />
      {!HIDE_SORT_SECTION_PLP_TYPES.includes(pageContentType) ? (
        <DesktopSortWrapper>
          {totalFilters > 0 && (
            <ResetAllFilters onClick={handleResetAllFilters}>
              <Refresh color="#000" width={12} height={12} />
              <span>
                <Trans>Reset all</Trans>
              </span>
            </ResetAllFilters>
          )}

          <Sort handleScrollToTop={handleScrollToTop} />
        </DesktopSortWrapper>
      ) : null}
    </>
  );
}

export { HeaderSortSection };
